/**
 * Email Intake Queue Repository Implementation
 * Implements the EmailIntakeQueueRepository interface
 * Coordinates between API calls and mappers
 */

import { EmailIntakeQueueRepository } from "../../domain/repositories/EmailIntakeQueueRepository";
import {
  EmailIntakeQueueResultEntity,
  EmailIntakeQueueOperationResult,
  EmailStatus,
  EmailCategory,
} from "../../domain/entities/EmailIntakeQueueEntity";
import {
  fetchEmails,
  updateEmailStatus,
} from "../api/emailIntakeQueueApi";
import { EmailIntakeQueueMapper } from "../mappers/EmailIntakeQueueMapper";

export class EmailIntakeQueueRepositoryImpl implements EmailIntakeQueueRepository {
  /**
   * Fetch emails with optional filtering, pagination, and sorting
   */
  async fetchEmails(params?: {
    status?: EmailStatus;
    category?: EmailCategory;
    subdomain?: string;
    search?: string;
    reason?: string;
    limit?: number;
    offset?: number;
    sort_by?: 'created_at' | 'received_at' | 'updated_at';
    sort_order?: 'asc' | 'desc';
  }): Promise<EmailIntakeQueueResultEntity> {
    const response = await fetchEmails(params);
    return EmailIntakeQueueMapper.toEmailIntakeQueueResultEntity(response);
  }

  /**
   * Update status for one or multiple emails
   */
  async updateStatus(
    ids: number[],
    status: 'ignore' | 'pushed'
  ): Promise<EmailIntakeQueueOperationResult> {
    const response = await updateEmailStatus(ids, status);
    return EmailIntakeQueueMapper.toEmailIntakeQueueOperationResult(response);
  }
}

